<template>
  <report-section 
    title="脉率统计" 
    :xyReportTemplateType="reportDetailModel.xyReportTemplateType">
    <template v-slot:content>
      <div class="section-pulse-content">
        <div class="pulse-stats-row">
          <div class="pulse-stats-item">
            <div class="pulse-value">平均脉率: {{ reportDetailModel.averagePulseStr }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">最大脉率: {{ reportDetailModel.maxPulseStr }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">最小脉率: {{ reportDetailModel.minPulseStr }}</div>
          </div>
        </div>

        <!-- <div class="pulse-stats-row">
          
          <div class="pulse-stats-item">
            <div class="pulse-value">分析心跳次数: {{ reportDetailModel.heartbeatCount || "1984" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">平均心率: {{ reportDetailModel.averageHeartRate || "80.74" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">心动过速搏动次数 (>120bpm): {{ reportDetailModel.tachycardiaCount || "0" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">占比: {{ reportDetailModel.tachycardiaRatio || "0.00%" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">最小心率: {{ reportDetailModel.minHeartRate || "61" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">发生时间: {{ reportDetailModel.minHeartRateTime || "10:54" }}</div>
          </div>
        </div>

        <div class="pulse-stats-row">
          <div class="pulse-stats-item">
            <div class="pulse-value">最大RR间隔: {{ reportDetailModel.maxRRInterval || "981" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">发生时间: {{ reportDetailModel.maxRRIntervalTime || "11:02" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">心动过缓搏动次数 (<40bpm): {{ reportDetailModel.bradycardiaCount || "0" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">占比: {{ reportDetailModel.bradycardiaRatio || "0.00%" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">最大心率: {{ reportDetailModel.maxHeartRate || "111" }}</div>
          </div>
          <div class="pulse-stats-item">
            <div class="pulse-value">发生时间: {{ reportDetailModel.maxHeartRateTime || "11:02" }}</div>
          </div>
        </div> -->
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import KeyValueUnit from "@c/report-detail/single-blood-oxygen-report/common/new-key-value-unit/key-value-unit-blood-oxygen-report.vue";

export default {
  components: {
    ReportSection,
    KeyValueUnit,
  },

  props: {
    reportDetailModel: Object,
  },
};
</script>

<style lang="scss" scoped>
.section-pulse-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.pulse-stats-row {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.pulse-stats-item {
  flex: 1;
  text-align: left;
  margin-bottom: 10px;
}

.pulse-value {
  font-size: 16px;
  color: #000;
  line-height: 1.5;
}
</style> 